import React from "react";
import axios from "axios";

export const loginApi = async (email, password) => {

  try {
    let url = `https://visapro-api.tcore.online/api/v1/auth/login`;
    const response = await axios.post(url, {
      email,
      password,
    });
    const login = {
      data: response.data,
    };

    function setWithExpiry(key, value, ttl) {
      const now = new Date()
      const item = {
        value: value,
        expiry: now.getTime() + ttl,
      }
      localStorage.setItem(key, JSON.stringify(item))
    }
    setWithExpiry("userData", login.data.data, 604800000)

    return login;
  } catch (error) {
    const login = {
      error: error,
    };
    return login;
  }
};
